// Indian States & UTs with GST state codes
export const INDIAN_STATES = [
  { code: '01', short: 'JK', name: 'Jammu & Kashmir' },
  { code: '02', short: 'HP', name: 'Himachal Pradesh' },
  { code: '03', short: 'PB', name: 'Punjab' },
  { code: '04', short: 'CH', name: 'Chandigarh' },
  { code: '05', short: 'UK', name: 'Uttarakhand' },
  { code: '06', short: 'HR', name: 'Haryana' },
  { code: '07', short: 'DL', name: 'Delhi' },
  { code: '08', short: 'RJ', name: 'Rajasthan' },
  { code: '09', short: 'UP', name: 'Uttar Pradesh' },
  { code: '10', short: 'BR', name: 'Bihar' },
  { code: '11', short: 'SK', name: 'Sikkim' },
  { code: '12', short: 'AR', name: 'Arunachal Pradesh' },
  { code: '13', short: 'NL', name: 'Nagaland' },
  { code: '14', short: 'MN', name: 'Manipur' },
  { code: '15', short: 'MZ', name: 'Mizoram' },
  { code: '16', short: 'TR', name: 'Tripura' },
  { code: '17', short: 'ML', name: 'Meghalaya' },
  { code: '18', short: 'AS', name: 'Assam' },
  { code: '19', short: 'WB', name: 'West Bengal' },
  { code: '20', short: 'JH', name: 'Jharkhand' },
  { code: '21', short: 'OR', name: 'Odisha' },
  { code: '22', short: 'CT', name: 'Chhattisgarh' },
  { code: '23', short: 'MP', name: 'Madhya Pradesh' },
  { code: '24', short: 'GJ', name: 'Gujarat' },
  { code: '26', short: 'DD', name: 'Dadra & Nagar Haveli and Daman & Diu' },
  { code: '27', short: 'MH', name: 'Maharashtra' },
  { code: '29', short: 'KA', name: 'Karnataka' },
  { code: '30', short: 'GA', name: 'Goa' },
  { code: '31', short: 'LD', name: 'Lakshadweep' },
  { code: '32', short: 'KL', name: 'Kerala' },
  { code: '33', short: 'TN', name: 'Tamil Nadu' },
  { code: '34', short: 'PY', name: 'Puducherry' },
  { code: '35', short: 'AN', name: 'Andaman & Nicobar Islands' },
  { code: '36', short: 'TS', name: 'Telangana' },
  { code: '37', short: 'AP', name: 'Andhra Pradesh' },
  { code: '38', short: 'LA', name: 'Ladakh' },
];

export const getStateByCode = (code) =>
  INDIAN_STATES.find((s) => s.code === code);

export const getStateByShort = (short) =>
  INDIAN_STATES.find((s) => s.short === short);

export const GST_RATES = [0, 5, 12, 18, 28];
